import React, { useContext } from "react";
import { AdminDashboardContext } from "src/components/Context/MyContext";
import ReplyMessageBox from "src/components/atoms/ReplyMessageBox";
import ChatInputField from "src/components/atoms/inputfields/ChatInputField";

const ReplyComponent = ({
  replyMessage,
  setReplyMessage,
  openAttachment,
  inputValue,
  setInputValue,
  handleEnter,
  loading,
  handleUpload,
}) => {
  const {sendTypingOnSignal,sendTypingOffSignal} = useContext(AdminDashboardContext)
  return (
    <div className=" flex flex-col ">
      <div className="mr-3 ml-5 ">
        <ReplyMessageBox
          replyMessage={replyMessage}
          setReplyMessage={setReplyMessage}
        />
      </div>
      <ChatInputField
        inputCss="!bg-transparent"
        openAttachment={openAttachment}
        inputValue={inputValue}
        setInputValue={setInputValue}
        handleEnter={handleEnter}
        loading={loading}
        sendTypingOffSignal={sendTypingOffSignal}
        sendTypingOnSignal={sendTypingOnSignal}
        handleUpload={handleUpload}
      />
    </div>
  );
};

export default ReplyComponent;
